import { Link } from 'react-router-dom';
import { handleDownloadClick } from '../utils/deviceDetection';

const DownloadAppButton = ({ additionalClasses = '', label }) => {
    const handleClick = (e) => {
        if (window.gtag) {
            window.gtag('event', 'download_app_click', { button_label: label || 'Download the WearTwice app' });
        }
        handleDownloadClick(e);
    };

    return (
        <Link to="/qr-code" onClick={handleClick} className={`py-3 px-4 text-[#DDFDB3] bg-[#062319] rounded-lg hover:bg-[#093728] transition-colors ${additionalClasses}`}>
            <span className="font-bold text-sm md:text-base">{label || 'Download the WearTwice app'}</span>
        </Link>
    )
}

export default DownloadAppButton;